import { createAsyncThunk } from '@reduxjs/toolkit';

import * as livekit from 'endpoints/live-kit';
import { ApiResponse } from 'endpoints/endpoint';
import { apiRequest } from 'client/utils';

export const getToken = createAsyncThunk<
  ApiResponse<livekit.GetTokenResult, livekit.GetTokenError>,
  livekit.GetTokenParams,
  { rejectValue: string }
>('livekit/getToken', async (data, { rejectWithValue }) => {
  try {
    const response = await apiRequest<livekit.GetTokenParams, livekit.GetTokenResult, livekit.GetTokenError>(
      livekit.getToken,
      {
        retries: false,
        data,
        apiTarget: process.env.MODE === 'local' ? 'client' : 'client-v2',
      },
    )();

    return response;
  } catch (e) {
    return rejectWithValue((e as Error).message);
  }
});
